import ErrorLine from 'components/ErrorLine'
import { io } from 'socket.io-client'
import { useEffect } from 'react'
import { useState } from 'react'
import { displayError } from 'util/screenUtils'
import { TextField } from '@material-ui/core'
import { setPlayListIndex } from 'redux/actions/harmonizeActions'
import { setPlayList } from 'redux/actions/messagesActions'
import { useDispatch } from 'react-redux'
import { buildNewPlaylistEntries } from 'util/playlistUtils'
import { setEndOfMessages } from 'redux/actions/messagesActions'
import { setShowSearch } from 'redux/actions/displayActions'

let socket
export default function Searcher() {
    const [searchInput, setSearchInput] = useState('')
    const [searchResults, setSearchResults] = useState('')
    const [error, setError] = useState()
    const dispatch = useDispatch()

    const connectSearch = () => {
        try {
            const channelAddress = `${process.env.REACT_APP_SOCIAL_SEARCH_SERVICE}`
            console.log(`New connection to ${channelAddress}`)
            socket = io(channelAddress, {
                reconnectionDelay: 10000
            })
            //socketActions(socket, channel, studioOwner)
            socket.on('search-results', async (results) => {
                console.log('got search results', results)
                if (Array.isArray(results)) {
                    if (results.length) {
                        const newPlaylist = await buildNewPlaylistEntries(results)
                        dispatch(setEndOfMessages(true)) //To prevent fetch lookahead
                        dispatch(setPlayList(newPlaylist))
                        dispatch(setPlayListIndex(0))
                        dispatch(setShowSearch(false))
                        setSearchResults('')
                        setSearchInput('')
                    } else {
                        setSearchInput('')
                        setSearchResults('No results')
                    }
                } else {
                    setSearchResults(results)
                }
            })
            socket.on('connect', () => {
                //socket.emit('search', 'the world')
            })
        } catch (error) {
            console.error(error)
            displayError(error, setError)
        }
    }
    const displaySearchInput = () => {
        return (
            <TextField
                value={searchInput}
                onChange={(event) => {
                    const { target } = event
                    setSearchInput(target.value)
                    //socket.emit('search', searchInput)
                }}
                onKeyPress={(event) => {
                    const { key } = event
                    if (key === 'Enter') {
                        socket.emit('search', searchInput)
                        setSearchInput('')
                    }
                }}
                fullWidth
                multiline

                label={`Search using # for hashtag, otherwise full text`}
                inputProps={{
                    maxLength: process.env.REACT_APP_MAX_HARMONIZE_MESSAGE_NAME_LENGTH,
                    style: {
                        height: "5vh"
                    },
                }}
            />

        )
    }

    useEffect(() => {
        console.log('Searcher useEffect')
        connectSearch()
        return () => {
            if (socket) {
                console.log('...disconnect Searcher')
                socket.disconnect()
            }
        }
    }, [])
    return (
        <div style={{
            backgroundColor: 'white', display: 'flex', flexDirection: 'column', width: '100%'
        }}>
            <ErrorLine error={error} />
            {displaySearchInput()}
            {searchResults}
        </div>
    )
}